import { useQuery } from '@tanstack/react-query';
import { storesQueryOptions } from '../query/query-options';
import { storeLayout } from '../router';

export function useStore() {
  const { storeId } = storeLayout.useParams();
  const { store: contextStore } = storeLayout.useRouteContext();
  // enabled:false — read-only subscriber; never triggers a fetch. Unlike skipToken
  // (a truthy Symbol), undefined queryFn lets TanStack's fallback observer scan
  // find the real queryFn when query.fetch() is called by other code paths.
  const { data: stores } = useQuery({ ...storesQueryOptions(), enabled: false });

  return stores?.find((s) => s.id === storeId) ?? contextStore;
}
